// IntervalBillReport.js
import React, { Component } from "react";
import { connect } from "react-redux";
import { getIntervalBillReport } from "../../actions/ReportsActions";
import LoadingBar from "../utils/loadingBar";
import NotFound from "../utils/notFound";
import TableLabel from "../utils/tableLabelGenerator";
import {
  Table,
  Button,
  Icon,
  Container,
  Pagination,
} from "semantic-ui-react";
import { priceToPersian } from "../utils/numberUtils";
import {
  getTodayGregorian,
  toGregorian,
  getTodayJalaali,
  standardTimeToJalaali
} from "../utils/jalaaliUtils";


class IntervalBillReport extends Component {
  state = { 
    report: null, 
    intervalReports: null, 
    isLoading: false, 
    activePage: 1,
    totalPageCount: 1, 
  };

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filterData !== this.props.filterData) {
      this.fetchData();
    }
  }

  convertToGregorian = (date) => {
    let date_values = date.split("/");
    let g = toGregorian(
      parseInt(date_values[0]),
      parseInt(date_values[1]),
      parseInt(date_values[2])
    );
    return `${g.gy}-${g.gm}-${g.gd}`;
  };

  getIntervalBillsData(local_from_date, local_to_date, page = 1){
    this.props.getIntervalBillReport(
      this.convertToGregorian(local_from_date), 
      this.convertToGregorian(local_to_date),
      this.props.filterData.selectedPaymentType,
      this.props.filterData.selectedBillStatus,
      page, 
    ).then(() => {
      this.setState({
        isLoading: false, 
        intervalReports: this.props.intervalReports,
        activePage: page,
        totalPageCount: Math.ceil(this.props.intervalReports.count / 25),
      })
    });
  }

  fetchData = () => {
    this.setState({
      isLoading: true,
      intervalReports: null, 
    })
    const { fromDate, toDate } = this.props.filterData;
    let local_from_date = fromDate.replaceAll("-", "/");
    let local_to_date = toDate.replaceAll("-", "/");;
    if (local_from_date == "" || local_to_date == "") {
      local_from_date = getTodayJalaali();
      local_to_date = getTodayJalaali();
    }
    this.getIntervalBillsData(local_from_date, local_to_date, this.state.activePage);
    
  };

  changePage = (_, { activePage }) => {
    this.setState({ activePage }, () => {
      this.fetchData(); // Fetch data for the new active page
    });
  };

  render() {
    const { intervalReports, activePage, totalPageCount } = this.state;
  
    return (
      <Container>
        {this.state.isLoading && <LoadingBar />}
        {!this.state.isLoading && intervalReports && intervalReports.results && intervalReports.results.length === 0 && (
          <NotFound />
        )}
        {!this.state.isLoading && intervalReports && intervalReports.results && intervalReports.results.length > 0 && (
          <Table celled striped>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell className="text-right" colSpan="12">
                  فاکتور های بسته شده
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
              <React.Fragment>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell className="text-center">
                      عملیات
                    </Table.HeaderCell>
                    <Table.HeaderCell className="text-center">
                      <TableLabel count={10}> قیمت کل</TableLabel>
                    </Table.HeaderCell>
                    <Table.HeaderCell className="text-center">
                      <TableLabel count={9}> قیمت خام بدون تخفیف</TableLabel>
                    </Table.HeaderCell>
                    <Table.HeaderCell className="text-center">
                      <TableLabel count={8}> تخفیف کل</TableLabel>
                    </Table.HeaderCell>
                    {window.localStorage.type === "admin" ? (
                      <Table.HeaderCell className="text-center">
                        <TableLabel count={7}> سود</TableLabel>
                      </Table.HeaderCell>
                    ) : null}
                    <Table.HeaderCell className="text-center">
                      <TableLabel count={6}> تعداد اقلام</TableLabel>
                    </Table.HeaderCell>
                    <Table.HeaderCell className="text-center">
                      <TableLabel count={5}> تاریخ بسته شدن</TableLabel>
                    </Table.HeaderCell>
                    <Table.HeaderCell className="text-center">
                      <TableLabel count={4}> شماره تلفن خریدار</TableLabel>
                    </Table.HeaderCell>
                    <Table.HeaderCell className="text-center">
                      <TableLabel count={3}> شعبه</TableLabel>
                    </Table.HeaderCell>
                    <Table.HeaderCell className="text-center">
                      <TableLabel count={2}> نام فروشنده</TableLabel>
                    </Table.HeaderCell>
                    <Table.HeaderCell className="text-center">
                      <TableLabel count={1}> شماره فاکتور</TableLabel>
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {
                  Object.keys(intervalReports.results).length
                    ? intervalReports.results.map((item) => {
                        return (
                          <Table.Row key={item.pk}>
                            <Table.Cell
                              className="text-center norm-latin"
                              collapsing
                            >
                              <Button
                                as="a"
                                href={`/factor/${item.pk}/print`}
                                target="_blank"
                                icon
                                labelPosition="right"
                                color="yellow"
                              >
                                <span className="yekan">چاپ فاکتور</span>
                                <Icon name="print" />
                              </Button>
                            </Table.Cell>
                            <Table.Cell
                              className="text-center norm-latin"
                              collapsing
                            >
                              <TableLabel count={10}>
                                <span>{priceToPersian(item.final_price)}</span>
                              </TableLabel>
                            </Table.Cell>
                            <Table.Cell
                              className="text-center norm-latin"
                              collapsing
                            >
                              <TableLabel count={9}>
                                <span>{priceToPersian(item.price)}</span>
                              </TableLabel>
                            </Table.Cell>
                            <Table.Cell
                              className="text-center norm-latin"
                              collapsing
                            >
                              <TableLabel count={8}>
                                <span>
                                  {priceToPersian(item.total_discount)}
                                </span>
                              </TableLabel>
                            </Table.Cell>
                            {window.localStorage.type === "admin" ? (
                              <Table.Cell
                                className="text-center norm-latin"
                                collapsing
                              >
                                <TableLabel count={7}>
                                  <span>{priceToPersian(item.profit)}</span>
                                </TableLabel>
                              </Table.Cell>
                            ) : null}
                            <Table.Cell
                              className="text-center norm-latin"
                              collapsing
                            >
                              <TableLabel count={6}>
                                <span>{item.items_count}</span>
                              </TableLabel>
                            </Table.Cell>
                            <Table.Cell
                              className="text-center norm-latin"
                              collapsing
                            >
                              <TableLabel count={5}>
                                <span>
                                  {standardTimeToJalaali(item.close_date)}
                                </span>
                              </TableLabel>
                            </Table.Cell>
                            <Table.Cell
                              className="text-center norm-latin"
                              collapsing
                            >
                              <TableLabel count={4}>
                                <span>{item.buyer.phone_number}</span>
                              </TableLabel>
                            </Table.Cell>
                            <Table.Cell
                              className="text-center norm-latin"
                              collapsing
                            >
                              <TableLabel count={3}>
                                <span>{item.branch && item.branch.name}</span>
                              </TableLabel>
                            </Table.Cell>
                            <Table.Cell
                              className="text-center norm-latin"
                              collapsing
                            >
                              <TableLabel count={2}>
                                <span>{item.seller.username}</span>
                              </TableLabel>
                            </Table.Cell>
                            <Table.Cell
                              className="text-center norm-latin"
                              collapsing
                            >
                              <TableLabel count={1}>
                                <span>{item.bill_code}</span>
                              </TableLabel>
                            </Table.Cell>
                          </Table.Row>
                        );
                      })
                    : null}
                </Table.Body>
                <Table.Footer fullWidth hidden={totalPageCount < 2}>
                  <Table.Row>
                    <Table.HeaderCell colSpan={11} className="norm-latin">
                      <Pagination
                        className="norm-latin"
                        defaultActivePage={1}
                        activePage={activePage}
                        onPageChange={this.changePage}
                        totalPages={totalPageCount}
                      />
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Footer>
              </React.Fragment>
          </Table>
        )}
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  intervalReports: state.reports.intervalBillReport,
});

export default connect(mapStateToProps, { getIntervalBillReport })(
  IntervalBillReport
);
